<template>
  <div
    class="store-auto-response-edit-item"
  >
    <Select
      :label="$t('STAFF_MANAGEMENT.SHOP_LOCATIONS')"
      :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_SHOP')"
      v-model="syncLocationCode"
      :items="currentUserDict.shopLocations"
      item-text="name"
      item-value="code"
      solo
      flat
      class="mb-6"
      :disabled="isUpdateStatus"
    />
    <Textarea
      :label="$t('STAFF_MANAGEMENT.AUTO_REPLY_MESSAGE')"
      :placeholder="$t('STAFF_MANAGEMENT.PLEASE_ENTER_AUTO_REPLY_MESSAGE')"
      hide-details
      :rows="3"
      class="mb-6"
      v-model.trim="syncReplyBody"
    />
    <div class="text-right mb-1">
      <v-btn
        color="neutral-045"
        outlined
        class="text-body-2 cancel-btn mr-3"
        min-width="137"
        max-height="32"
        @click="$emit('cancel-setting')"
      >
        {{ $t('CANCEL') }}
      </v-btn>
      <v-btn
        depressed
        color="primary-001"
        class="text-body-2"
        min-width="137"
        max-height="32"
        @click="$emit('confirm-setting')"
        :dark="!isDisableCreateBtn"
        :disabled="isDisableCreateBtn"
        :loading="isSubmitLoading"
      >
        {{ submitTitle }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Select from '@/components/form/Select.vue';
import Textarea from '@/components/form/Textarea.vue';

export default {
  name: 'StoreAutoReplySetting',
  components: {
    Select,
    Textarea
  },
  props: {
    locationCode: {
      type: String,
      default: ''
    },
    replyBody: {
      type: String,
      default: ''
    },
    isSubmitLoading: {
      type: Boolean,
      default: false
    },
    isUpdateStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tempAutoReply: {
        locationCode: '',
        replyBody: ''
      }
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    syncLocationCode: {
      get() {
        return this.locationCode;
      },
      set(val) {
        this.$emit('update:locationCode', val);
      }
    },
    syncReplyBody: {
      get() {
        return this.replyBody;
      },
      set(val) {
        this.$emit('update:replyBody', val);
      }
    },
    isDisableCreateBtn() {
      if (this.syncReplyBody === '') return true;
      if (this.syncLocationCode === '') return true;
      return false;
    },
    submitTitle() {
      return this.isUpdateStatus ? this.$t('SAVE') : this.$t('CREATE');
    }
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>

::v-deep.cancel-btn {
  .v-btn__content {
    color: $neutral-cold-051;
  }
}

.store-auto-response-edit-item {
  border: 1px solid $neutral-cold-054;
  border-radius: 4px;
  padding: 20px 24px;
}
</style>
